"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSchedulerApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class GroupSchedulerApi extends runtime.BaseAPI {
    /**
     * Book a new group scheduler timeslot
     * Book a new group scheduler timeslot
     */
    async bookGroupSchedulerTimeslotRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling bookGroupSchedulerTimeslot.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling bookGroupSchedulerTimeslot.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling bookGroupSchedulerTimeslot.');
        }
        if (requestParameters.timeslotId === null || requestParameters.timeslotId === undefined) {
            throw new runtime.RequiredError('timeslotId', 'Required parameter requestParameters.timeslotId was null or undefined when calling bookGroupSchedulerTimeslot.');
        }
        if (requestParameters.bookGroupSchedulerTimeslotRequest === null || requestParameters.bookGroupSchedulerTimeslotRequest === undefined) {
            throw new runtime.RequiredError('bookGroupSchedulerTimeslotRequest', 'Required parameter requestParameters.bookGroupSchedulerTimeslotRequest was null or undefined when calling bookGroupSchedulerTimeslot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/timeslots/{timeslotId}/book`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))).replace(`{${"timeslotId"}}`, encodeURIComponent(String(requestParameters.timeslotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BookGroupSchedulerTimeslotRequestToJSON)(requestParameters.bookGroupSchedulerTimeslotRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.BookGroupSchedulerTimeslot200ResponseFromJSON)(jsonValue));
    }
    /**
     * Book a new group scheduler timeslot
     * Book a new group scheduler timeslot
     */
    async bookGroupSchedulerTimeslot(requestParameters, initOverrides) {
        const response = await this.bookGroupSchedulerTimeslotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Cancel a group scheduler timeslot
     * Cancel a group scheduler timeslot
     */
    async cancelGroupSchedulerTimeslotRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling cancelGroupSchedulerTimeslot.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling cancelGroupSchedulerTimeslot.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling cancelGroupSchedulerTimeslot.');
        }
        if (requestParameters.timeslotId === null || requestParameters.timeslotId === undefined) {
            throw new runtime.RequiredError('timeslotId', 'Required parameter requestParameters.timeslotId was null or undefined when calling cancelGroupSchedulerTimeslot.');
        }
        if (requestParameters.cancelGroupSchedulerTimeslotRequest === null || requestParameters.cancelGroupSchedulerTimeslotRequest === undefined) {
            throw new runtime.RequiredError('cancelGroupSchedulerTimeslotRequest', 'Required parameter requestParameters.cancelGroupSchedulerTimeslotRequest was null or undefined when calling cancelGroupSchedulerTimeslot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/timeslots/{timeslotId}/cancel`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))).replace(`{${"timeslotId"}}`, encodeURIComponent(String(requestParameters.timeslotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.CancelGroupSchedulerTimeslotRequestToJSON)(requestParameters.cancelGroupSchedulerTimeslotRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Cancel a group scheduler timeslot
     * Cancel a group scheduler timeslot
     */
    async cancelGroupSchedulerTimeslot(requestParameters, initOverrides) {
        const response = await this.cancelGroupSchedulerTimeslotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Configure a new group scheduler timeslot
     * Configure a new group scheduler timeslot
     */
    async configureGroupSchedulerTimeslotRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling configureGroupSchedulerTimeslot.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling configureGroupSchedulerTimeslot.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling configureGroupSchedulerTimeslot.');
        }
        if (requestParameters.timeslotId === null || requestParameters.timeslotId === undefined) {
            throw new runtime.RequiredError('timeslotId', 'Required parameter requestParameters.timeslotId was null or undefined when calling configureGroupSchedulerTimeslot.');
        }
        if (requestParameters.configureGroupSchedulerTimeslot === null || requestParameters.configureGroupSchedulerTimeslot === undefined) {
            throw new runtime.RequiredError('configureGroupSchedulerTimeslot', 'Required parameter requestParameters.configureGroupSchedulerTimeslot was null or undefined when calling configureGroupSchedulerTimeslot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/timeslots/{timeslotId}/configure`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))).replace(`{${"timeslotId"}}`, encodeURIComponent(String(requestParameters.timeslotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.ConfigureGroupSchedulerTimeslotToJSON)(requestParameters.configureGroupSchedulerTimeslot),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Configure a new group scheduler timeslot
     * Configure a new group scheduler timeslot
     */
    async configureGroupSchedulerTimeslot(requestParameters, initOverrides) {
        const response = await this.configureGroupSchedulerTimeslotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new group scheduler timeslot
     * Create a new group scheduler timeslot
     */
    async createGroupSchedulerTimeslotRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling createGroupSchedulerTimeslot.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGroupSchedulerTimeslot.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling createGroupSchedulerTimeslot.');
        }
        if (requestParameters.createGroupSchedulerTimeslot === null || requestParameters.createGroupSchedulerTimeslot === undefined) {
            throw new runtime.RequiredError('createGroupSchedulerTimeslot', 'Required parameter requestParameters.createGroupSchedulerTimeslot was null or undefined when calling createGroupSchedulerTimeslot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/timeslots`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.CreateGroupSchedulerTimeslotToJSON)(requestParameters.createGroupSchedulerTimeslot),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CreateClient200ResponseFromJSON)(jsonValue));
    }
    /**
     * Create a new group scheduler timeslot
     * Create a new group scheduler timeslot
     */
    async createGroupSchedulerTimeslot(requestParameters, initOverrides) {
        const response = await this.createGroupSchedulerTimeslotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a group scheduler attendance
     * Delete a group scheduler attendance
     */
    async deleteGroupSchedulerAttendanceRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling deleteGroupSchedulerAttendance.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteGroupSchedulerAttendance.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling deleteGroupSchedulerAttendance.');
        }
        if (requestParameters.timeslotId === null || requestParameters.timeslotId === undefined) {
            throw new runtime.RequiredError('timeslotId', 'Required parameter requestParameters.timeslotId was null or undefined when calling deleteGroupSchedulerAttendance.');
        }
        if (requestParameters.deleteGroupSchedulerAttendanceRequest === null || requestParameters.deleteGroupSchedulerAttendanceRequest === undefined) {
            throw new runtime.RequiredError('deleteGroupSchedulerAttendanceRequest', 'Required parameter requestParameters.deleteGroupSchedulerAttendanceRequest was null or undefined when calling deleteGroupSchedulerAttendance.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/timeslots/{timeslotId}/delete-attendance`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))).replace(`{${"timeslotId"}}`, encodeURIComponent(String(requestParameters.timeslotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.DeleteGroupSchedulerAttendanceRequestToJSON)(requestParameters.deleteGroupSchedulerAttendanceRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Delete a group scheduler attendance
     * Delete a group scheduler attendance
     */
    async deleteGroupSchedulerAttendance(requestParameters, initOverrides) {
        const response = await this.deleteGroupSchedulerAttendanceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a group scheduler timeslot
     * Delete a group scheduler timeslot
     */
    async deleteGroupSchedulerTimeslotRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling deleteGroupSchedulerTimeslot.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteGroupSchedulerTimeslot.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling deleteGroupSchedulerTimeslot.');
        }
        if (requestParameters.timeslotId === null || requestParameters.timeslotId === undefined) {
            throw new runtime.RequiredError('timeslotId', 'Required parameter requestParameters.timeslotId was null or undefined when calling deleteGroupSchedulerTimeslot.');
        }
        if (requestParameters.deleteGroupSchedulerTimeslotRequest === null || requestParameters.deleteGroupSchedulerTimeslotRequest === undefined) {
            throw new runtime.RequiredError('deleteGroupSchedulerTimeslotRequest', 'Required parameter requestParameters.deleteGroupSchedulerTimeslotRequest was null or undefined when calling deleteGroupSchedulerTimeslot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/timeslots/{timeslotId}/delete`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))).replace(`{${"timeslotId"}}`, encodeURIComponent(String(requestParameters.timeslotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.DeleteGroupSchedulerTimeslotRequestToJSON)(requestParameters.deleteGroupSchedulerTimeslotRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Delete a group scheduler timeslot
     * Delete a group scheduler timeslot
     */
    async deleteGroupSchedulerTimeslot(requestParameters, initOverrides) {
        const response = await this.deleteGroupSchedulerTimeslotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieves curriculum scheduler progress information
     * Retrieves curriculum scheduler progress information
     */
    async getCurriculumSchedulerProgressRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling getCurriculumSchedulerProgress.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCurriculumSchedulerProgress.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling getCurriculumSchedulerProgress.');
        }
        const queryParameters = {};
        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }
        if (requestParameters.packageInstanceId !== undefined) {
            queryParameters['packageInstanceId'] = requestParameters.packageInstanceId;
        }
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/progress`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetCurriculumSchedulerProgress200ResponseFromJSON)(jsonValue));
    }
    /**
     * Retrieves curriculum scheduler progress information
     * Retrieves curriculum scheduler progress information
     */
    async getCurriculumSchedulerProgress(requestParameters, initOverrides) {
        const response = await this.getCurriculumSchedulerProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get group scheduler attendees
     * Get group scheduler attendees
     */
    async getGroupSchedulerAttendeesRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling getGroupSchedulerAttendees.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGroupSchedulerAttendees.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling getGroupSchedulerAttendees.');
        }
        const queryParameters = {};
        if (requestParameters.timeslotId !== undefined) {
            queryParameters['timeslotId'] = requestParameters.timeslotId;
        }
        if (requestParameters.timeslotRecurringDate !== undefined) {
            queryParameters['timeslotRecurringDate'] = requestParameters.timeslotRecurringDate;
        }
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/attendees`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.SlotAttendanceFromJSON));
    }
    /**
     * Get group scheduler attendees
     * Get group scheduler attendees
     */
    async getGroupSchedulerAttendees(requestParameters, initOverrides) {
        const response = await this.getGroupSchedulerAttendeesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get timeslots for a group scheduler
     * Get timeslots for a group scheduler
     */
    async getGroupSchedulerTimeslotsRaw(requestParameters, initOverrides) {
        if (requestParameters.startTime === null || requestParameters.startTime === undefined) {
            throw new runtime.RequiredError('startTime', 'Required parameter requestParameters.startTime was null or undefined when calling getGroupSchedulerTimeslots.');
        }
        if (requestParameters.endTime === null || requestParameters.endTime === undefined) {
            throw new runtime.RequiredError('endTime', 'Required parameter requestParameters.endTime was null or undefined when calling getGroupSchedulerTimeslots.');
        }
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling getGroupSchedulerTimeslots.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGroupSchedulerTimeslots.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling getGroupSchedulerTimeslots.');
        }
        const queryParameters = {};
        if (requestParameters.startTime !== undefined) {
            queryParameters['startTime'] = requestParameters.startTime.toISOString();
        }
        if (requestParameters.endTime !== undefined) {
            queryParameters['endTime'] = requestParameters.endTime.toISOString();
        }
        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/timeslots`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.GroupSchedulerTimeslotFromJSON));
    }
    /**
     * Get timeslots for a group scheduler
     * Get timeslots for a group scheduler
     */
    async getGroupSchedulerTimeslots(requestParameters, initOverrides) {
        const response = await this.getGroupSchedulerTimeslotsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Join a curriculum scheduler
     */
    async joinCurriculumSchedulerRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling joinCurriculumScheduler.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling joinCurriculumScheduler.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling joinCurriculumScheduler.');
        }
        if (requestParameters.joinCurriculumSchedulerRequest === null || requestParameters.joinCurriculumSchedulerRequest === undefined) {
            throw new runtime.RequiredError('joinCurriculumSchedulerRequest', 'Required parameter requestParameters.joinCurriculumSchedulerRequest was null or undefined when calling joinCurriculumScheduler.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/join-curriculum`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.JoinCurriculumSchedulerRequestToJSON)(requestParameters.joinCurriculumSchedulerRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Join a curriculum scheduler
     */
    async joinCurriculumScheduler(requestParameters, initOverrides) {
        const response = await this.joinCurriculumSchedulerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Leave a curriculum scheduler
     */
    async leaveCurriculumSchedulerRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling leaveCurriculumScheduler.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling leaveCurriculumScheduler.');
        }
        if (requestParameters.groupSchedulerId === null || requestParameters.groupSchedulerId === undefined) {
            throw new runtime.RequiredError('groupSchedulerId', 'Required parameter requestParameters.groupSchedulerId was null or undefined when calling leaveCurriculumScheduler.');
        }
        if (requestParameters.leaveCurriculumSchedulerRequest === null || requestParameters.leaveCurriculumSchedulerRequest === undefined) {
            throw new runtime.RequiredError('leaveCurriculumSchedulerRequest', 'Required parameter requestParameters.leaveCurriculumSchedulerRequest was null or undefined when calling leaveCurriculumScheduler.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/group-schedulers/{groupSchedulerId}/leave-curriculum`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"groupSchedulerId"}}`, encodeURIComponent(String(requestParameters.groupSchedulerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.LeaveCurriculumSchedulerRequestToJSON)(requestParameters.leaveCurriculumSchedulerRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Leave a curriculum scheduler
     */
    async leaveCurriculumScheduler(requestParameters, initOverrides) {
        const response = await this.leaveCurriculumSchedulerRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.GroupSchedulerApi = GroupSchedulerApi;
//# sourceMappingURL=GroupSchedulerApi.js.map